/**
 * 配置编译环境和线上环境之间的切换
 * baseUrl: 域名地址
 * routerMode: 路由模式
 * imgBaseUrl: 图片所在域名地址
 */

let BASE_URL = process.env.VUE_APP_API_BASE;
let ROUTER_MODE = "history";
let IMG_BASE_URL = "http://www.hfmphe.net/";
export { BASE_URL, ROUTER_MODE, IMG_BASE_URL };

// let ROUTER_MODE = "";
//let IMG_BASE_URL = "http://qiniu.qihuangdoctor.com/";
// //设置跨域访问
// var app = express(
//     app.all('*', function(req, res, next) {
//         res.header("Access-Control-Allow-Origin", "*");
//         res.header('Access-Control-Allow-Headers', 'Content-Type, Content-Length, Authorization, Accept, X-Requested-With , yourHeaderFeild');
//         res.header("Access-Control-Allow-Methods","PUT,POST,GET,DELETE,OPTIONS");
//         res.header("X-Powered-By",' 3.2.1')
//         res.header("Content-Type", "application/json;charset=utf-8");
//         next();
//     })
// );


